import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { TdLoadingService } from '@covalent/core';
import { AdminService } from '../../../../services/admin/admin.service';
import { PetitionAdminConfigs } from '../../../../shared/admin-models/interfaces/petition-admin-configs.interface';

@Component({
  selector: 'app-config-panel',
  templateUrl: './config-panel.component.html',
  styleUrls: ['./config-panel.component.scss']
})
export class ConfigPanelComponent implements OnInit {
  configs: PetitionAdminConfigs = {
    id: null,
    clientId: null,
    petitionAddSmsText: '',
    petitionInVoteSmsText: '',
    petitionStatusChangedSmsText: '',
    cityHallFinishedTime: null,
    petitionPendingDate: null,
    petitionLegalProcessingDate: null,
    petitionVoteProcessDate: null,
    petitionLegalProcessDate: null,
    petitionMayorsFirstDecision: null,
    petitionMayorsSecondDecision: null,
    petitionMayorsFirstDecisionRegistration: null,
    petitionMayorsSecondDecisionRegistration: null,
    petitionCounterValue: null,
    cityHallUnitId: null,
    regionNameForNapr: '',
    regionValidationServiceEnabled: true
  };
  constructor(
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getConfigs();
  }
  getConfigs(): void {
    this._loadingService.register();
    this._adminService.getConfigs().subscribe(
      (res: PetitionAdminConfigs) => {
        this._loadingService.resolve();
        this.configs = res;
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  save(config: NgForm): void {
    if (config.valid) {
      if (config.dirty) {
        this._loadingService.register();
        this._adminService.saveConfigs(this.configs).subscribe(
          (res) => {
            this._loadingService.resolve();
            this._snackBar.open('პარამეტრები წარმატებით დამახსოვრდა', null, {
              horizontalPosition: 'left',
              duration: 2000,
              panelClass: 'green-snackbar'
            });
          },
          (err) => {
            this._loadingService.resolve();
            this._snackBar.open('დაფიქსირდა შეცდომა', null, {
              duration: 2000,
              panelClass: 'red-snackbar',
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        );
      }
    } else {
      this._snackBar.open(
        'გთხოვთ სწორად შეავსოთ მითითებული ველები ველები',
        null,
        {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/config-panel/config-panel.component.ts